// 在这里注册你的业务页面
// ################################## 开始使用自己的菜单-- 指向视图   ##########################################
export default [
	{ path: '/domain/group', name: 'DomainGroupManager', component: () => import('@/views/config/shortlink-group'), meta: {} },
	{ path: '/short-link/stats', name: 'ShortLinkStats', component: () => import('@/views/config/shortlink-stats'), meta: {} },
	{ path: '/country/whitelist', name: 'CountryWhitelist', component: () => import('@/views/country/white'), meta: {} },
	// 客服列表
	{
		path: '/kf/adminu',
		name: 'KfAdminUList',
		component: () => import(/* webpackChunkName: "KfAdminUList", */ '@/views/admin/Adminu'),
		meta: {}
	},
	// 域名列表
	{
		path: '/domian/list',
		name: 'CommonDomainManager',
		component: () => import(/* webpackChunkName: "CommonDomainManager", */ '@/views/config/common-domain'),
		meta: {}
	},
	{
		path: '/short-link/manage',
		name: 'ShortLinkManager',
		component: () => import(/* webpackChunkName: "ShortLinkManager", */ '@/views/config/shortlink'),
		meta: {}
	},
	{
		path: '/ip/list',
		name: 'IPOverview',
		component: () => import(/* webpackChunkName: "IPOverview", */ '@/views/ips/overview'),
		meta: {}
	},
	{
		path: '/config/system',
		name: 'SystemLanding',
		component: () => import(/* webpackChunkName: "SystemLanding", */ '@/views/config/system'),
		meta: {}
	}
];
